import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';

// Service Pages
import AllServices from './pages/AllServices';
import WebDevelopment from './pages/WebDevelopment';
import SEOOptimization from './pages/SEOOptimization';
import ITConsulting from './pages/ITConsulting';
import SystemManagement from './pages/SystemManagement';
import DataProcessing from './pages/DataProcessing';
import CustomSoftware from './pages/CustomSoftware';

// ScrollToTop Component
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};

// Home Page Component
const HomePage = () => (
  <>
    <Hero />
    <About />
    <Services />
    <Contact />
  </>
);

function App() {
  return (
    <Router>
      <div className="App bg-gray-900 min-h-screen">
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<AllServices />} />
            <Route path="/services/web-development" element={<WebDevelopment />} />
            <Route path="/services/seo-optimization" element={<SEOOptimization />} />
            <Route path="/services/it-consulting" element={<ITConsulting />} />
            <Route path="/services/system-management" element={<SystemManagement />} />
            <Route path="/services/data-processing" element={<DataProcessing />} />
            <Route path="/services/custom-software" element={<CustomSoftware />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
